import dayjs from 'dayjs';
import 'dayjs/locale/en-gb';
import 'dayjs/locale/fr';
import 'dayjs/locale/de';
import 'dayjs/locale/es';
import 'dayjs/locale/it';
import 'dayjs/locale/nl';
import 'dayjs/locale/pt';
import 'dayjs/locale/zh-cn';

import { getLocaleForLanguage } from 'ha/i18n';
import CookiesConstants from 'ha/constants/Cookies';

import impersonateUser from './impersonateUser';
import { fetchUser, fetchImpersonationInfo } from './actions';
import { getIsLoaded, getIsAdmin } from '../selectors';

const IMPERSONATION_QUERY_PARAMETER = 'id2';

export default async function initSession({ store, lang, setCookie }) {
  const localeFromLanguage = getLocaleForLanguage(lang);

  dayjs.locale(localeFromLanguage);

  const isLoaded = getIsLoaded(store.getState());

  if (!isLoaded) {
    await store.dispatch(fetchUser());
  }

  const isAdmin = getIsAdmin(store.getState());

  if (isAdmin) {
    setCookie(CookiesConstants.PWA_NEXT_ENABLED, 1, {
      // Server lib doesn't support numbers as expires value
      expires: new Date(new Date() * 1 + 30 * 864e5),
    });
  }

  if (process.browser) {
    if (isAdmin) {
      const urlObject = new URL(global.location.href);

      const impersonationTargetUserId = urlObject.searchParams.get(
        IMPERSONATION_QUERY_PARAMETER,
      );

      if (impersonationTargetUserId) {
        urlObject.searchParams.delete(IMPERSONATION_QUERY_PARAMETER);

        await store.dispatch(
          impersonateUser(
            parseInt(impersonationTargetUserId, 10),
            urlObject.toString(),
          ),
        );
      } else {
        await store.dispatch(fetchImpersonationInfo());
      }
    } else {
      await store.dispatch(fetchImpersonationInfo());
    }
  }
}
